module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bNoyFS/tc-custom/9781488058653.jpg?1728259324170",
      "alt": "This image is the cover for the book Five Days of Christmas, Morgan's Mercenaries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Five Days of Christmas, Morgan's Mercenaries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("New York Times")])]), _c('b', [_vm._v(" bestselling author Lindsay McKenna revisits a fan-favorite tale of a holiday happily-ever-after, originally published in 2001")]), _c('br'), _c('br'), _vm._v("Colt Hamlin doesn’t expect much under his tree this Christmas. After all, the world-weary mercenary is just looking to get his life back on track. But when his boss’s wife decides to work a little matchmaking magic, Colt finds himself face to face with Montana’s prettiest widow, Abbie Clemens. And their chemistry is nothing short of electric…\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lindsay McKenna\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A U.S. Navy veteran, she pioneered the military romance in 1993 with Captive of Fate, Silhouette Special edition. In 1989, she pioneered the 3-book series coming out monthly with the Love & Glory series.  Her heart is on honoring our military men and women.  Creator of the Wyoming Series and Shadow Warriors series for HQN, she writes emotionally intense love and suspense stories. Visit her online at "), _c('a', {
    attrs: {
      "href": "http://www.LindsayMcKenna.com"
    }
  }, [_vm._v("www.LindsayMcKenna.com")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0